import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import type { AlertSeverity } from 'state/notifications/notification.model';

interface LightAlertProps {
  children: ReactNode;
  className?: string;
  e2e?: string;
  severity: AlertSeverity;
  customIcon?: string;
}

/* Less agressive alert banner using faded (transparent) colors */

const iconBySeverity: Record<AlertSeverity, string> = {
  danger: 'error_outline',
  info: 'info_outline',
  secondary: 'info_outline',
  success: 'info_outline',
  warning: 'warning',
};
export const LightAlert: FC<LightAlertProps> = ({ severity, children, className, e2e, customIcon }) => (
  <div
    className={classNames(
      'alert mb-0 d-flex align-items-center p-2 fw-semibold',
      `alert-discreet-${severity}`,
      className,
    )}
    data-e2e={e2e}
  >
    <i className="icon icon-sm me-2 mb-auto">{customIcon ?? iconBySeverity[severity]}</i>
    {children}
  </div>
);
